import React, { useState , useEffect } from "react"
import { Redirect} from "react-router-dom"
import { passwordValidation } from '../utils/userValidetion'
import { useQuery } from '../utils/tools'
import ChangePasswordForm from "../components/ChangePasswordForm"
import { Alert } from '@mui/material'
import styles from './Login.module.scss'
import axios from "axios"


export default function ResetPassword() {
    const [ isLoggedIn, setIsLoggedIn ] = useState(false)
    const [ id , setId ] = useState('')
    const [ incompatiblePasswords , setIncompatiblePasswords ] = useState(false)
    const [ isError , setIsError ] = useState(false)
    const [ getResponse , setGetResponse ] = useState(false)
    let query = useQuery();
    const key_query = query.get('key')

    useEffect(() => {
        axios.get(`/api/resetPassword?key=${key_query}`)
        .then(res => res.data)
        .then(res => {
            setId(res._id)
            setGetResponse(true)
        })
        return () => {}
    }, [key_query])


    const updatePassword = (event, password, password2) => {
        event.preventDefault()
        if(!passwordValidation(password) || password !== password2){
            return setIncompatiblePasswords(true)
        }
        // fetch('/api/changePassword', {
        //     method: 'post',
        //     headers: {'Content-Type': 'application/json'},
        //     body: JSON.stringify({id, password })
        // })
        axios({
            method: 'post',
            url: '/api/changePassword',
            data: {id, password }
        }).then(res => {
            if (res.status === 200){
                setIsLoggedIn(true)
            } else {
                setIsError(true)
            }
          }).catch(e=> {
                setIsError(true)
          })
    }

    if (isLoggedIn) {
        return <Redirect to='/login' />
    }

    const resetPasswordForm = () => (
        <>
            <div className={styles['subTitleText']}>Reset Your Password</div>
            <ChangePasswordForm
                submitForm={updatePassword}
                input1PlaceHolder="Password"
                input2PlaceHolder="Confirm your password"
                ButtonPlaceHolder="Reset Password"
            />
            { incompatiblePasswords && 
                <Alert severity="error" classes={{root: styles['error']}}>Incompatible passwords</Alert> }
            { isError &&
                <Alert severity="error" classes={{root: styles['error']}}>Problems communicating with the server</Alert> }
        </>
    )

    const expiredLinkMessage = () => (
        <div className={styles['subTitleText']}>The link has expired</div>
    )


    return (
        <div className={styles['gridWrapper']}>
            <div className={styles['loginCard']}>
                {getResponse && (id ? resetPasswordForm() : expiredLinkMessage())} 
            </div>
        </div>
    )  
}
